//Util_MUI.tsx =================================================
import "../Util/Prototypes";

import * as Util from "../Util/Util";

import { MenuItem } from "@mui/material";

import React from "react";

//Build dropdown menu items.
export function buildSelectMenuItems(labels: string[], values: string[] | number[] = null, title: string = null, titleDisabled: boolean = false): JSX.Element[] {
   let i: number;
   let label: string;
   let value: string | number;
   let highlight: boolean;
   let sa: string[];
   let word1: string;
   let word2: string;
   let word3: string;
   const jsx: JSX.Element[] = [];

   //Set the title.
   if (title) {
      jsx.push(
         <MenuItem key={Util.uid()} value={title} disabled={titleDisabled}>
            {title}
         </MenuItem>,
      );
   }

   //Process all labels.
   for (i = 0; i < labels.length; i++) {
      label = labels[i];

      value = label;
      if (values) {
         value = values[i];
      }

      //Highlight text inside brackets.
      highlight = false;

      if (label.Contains("[") && label.Contains("]")) {
         highlight = true;

         sa = label.split("[");
         word1 = sa[0];
         word2 = sa[1];

         sa = word2.split("]");
         word2 = sa[0];
         word3 = sa[1];
      }

      //Build html.
      if (highlight) {
         jsx.push(
            <MenuItem key={Util.uid()} value={value}>
               {word1}&nbsp;<span style={{ fontWeight: 500 }}>{word2}</span>&nbsp;{word3}
            </MenuItem>,
         );
      } else {
         jsx.push(
            <MenuItem key={Util.uid()} value={value}>
               {label}
            </MenuItem>,
         );
      }

   }
   return jsx;
}
